import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { trasfertaApi } from '../services/api'
import { useAuth } from '../contexts/AuthContext'

interface Notifica {
  id: number
  tipo: 'albergo' | 'dipendenti'
  progetto: string
  nr_commessa: string
  importo: number
  confermato_at: string
}

function fmtEuro(v: number) {
  return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(v)
}

function fmtDataOra(iso: string) {
  return new Date(iso).toLocaleString('it-IT', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  })
}

export function NotificheBonifici() {
  const { user } = useAuth()
  const [notifiche, setNotifiche] = useState<Notifica[]>([])
  const navigate = useNavigate()

  useEffect(() => {
    if (!user) return
    const fetch = () => {
      trasfertaApi.notifichePendenti()
        .then(r => setNotifiche(r.data))
        .catch(() => {})
    }
    fetch()
    const t = setInterval(fetch, 60_000)
    return () => clearInterval(t)
  }, [user])

  const segnaLetta = (n: Notifica) => {
    trasfertaApi.segnaLetta(n.id, n.tipo).catch(() => {})
    setNotifiche(prev => prev.filter(x => !(x.id === n.id && x.tipo === n.tipo)))
  }

  if (notifiche.length === 0) return null

  return (
    <div style={{
      position: 'fixed', bottom: 24, right: 24, zIndex: 9999,
      display: 'flex', flexDirection: 'column', gap: 12, maxWidth: 380,
    }}>
      {notifiche.map(n => {
        const labelTipo = n.tipo === 'albergo' ? 'Albergo' : 'Dipendenti'
        const color = n.tipo === 'albergo' ? '#1e40af' : '#15803d'
        return (
          <div key={`${n.id}-${n.tipo}`} style={{
            background: '#fff',
            border: `2px solid ${color}`,
            borderRadius: 12,
            boxShadow: '0 4px 24px rgba(0,0,0,.18)',
            padding: '16px 20px',
            animation: 'notificaSlideIn 0.3s ease',
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
              <span style={{ fontSize: 22 }}>✅</span>
              <strong style={{ color, fontSize: 15 }}>Bonifico {labelTipo} Confermato</strong>
            </div>
            <div style={{ fontSize: 13, color: '#374151', marginBottom: 4 }}>
              <strong>{n.progetto}</strong> — {n.nr_commessa}
            </div>
            <div style={{ fontSize: 13, color: '#374151', marginBottom: 4 }}>
              Importo: <strong style={{ color }}>{fmtEuro(n.importo)}</strong>
            </div>
            <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 12 }}>
              Confermato il {fmtDataOra(n.confermato_at)}
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button
                onClick={() => { segnaLetta(n); navigate('/trasferte') }}
                style={{
                  flex: 1, background: color, color: '#fff', border: 'none',
                  borderRadius: 8, padding: '8px 12px', fontSize: 13,
                  fontWeight: 'bold', cursor: 'pointer',
                }}
              >
                → Vai alle Trasferte
              </button>
              <button
                onClick={() => segnaLetta(n)}
                style={{
                  background: '#f1f5f9', color: '#374151', border: 'none',
                  borderRadius: 8, padding: '8px 12px', fontSize: 13, cursor: 'pointer',
                }}
              >
                ✕
              </button>
            </div>
          </div>
        )
      })}
      <style>{`
        @keyframes notificaSlideIn {
          from { opacity: 0; transform: translateX(40px); }
          to   { opacity: 1; transform: translateX(0); }
        }
      `}</style>
    </div>
  )
}
